<template>
  <div>
    <b-row class="mt-2">
      <b-col md="8">
        <b-form-group>
          <b-form-input
            v-model="consultarprocedimiento"
            placeholder="Buscar por codigo o descripcion del procedimiento."
            type="text"
            class="d-inline-block"
          />
        </b-form-group>
      </b-col>
     
      <!-- <b-col
        md="3"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-form-group class="w-100">
          <v-select
            id="especialidad"
            v-model="consultarespecialidad"
            :options="especialidades"
            placeholder="Buscar por especialidad."
            :reduce="(option) => option.value"
            label="text"
            class="d-inline-block w-100"
          />
        </b-form-group>
      </b-col> -->
  
      <b-col
        cols="12"
        md="4"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-button variant="primary" @click="buscarProcedimiento">
          <font-awesome-icon icon="magnifying-glass" style="color: white" />
          <span style="color: white"> buscar</span>
        </b-button>
      </b-col>
      <b-col
        md="3"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        v-if="isXima"
      >
        <b-form-group class="w-100">
          <v-select
            id="establecimiento"
            v-model="consultarestablecimiento"
            :options="establecimientosList"
            :reduce="(option) => option.value"
            placeholder="Seleccionar establecimiento."
            label="text"
            class="d-inline-block w-100"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card class="principal">
        <b-col cols="12" class="pr-0 pl-0 mt-2">
          <b-table
            v-if="items.length > 0"
            bordered
            striped
            responsive
            :total-rows="totalRows"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(estadoJson)="data">
              <div class="row">
                <label class="col-6" >Iess: <label :class="data.item.estadoJson.iess? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.iess? 'Activo' : 'Inactivo' }} </label> </label> 
                <label class="col-6">Issfa: <label :class="data.item.estadoJson.issfa? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.issfa? 'Activo' : 'Inactivo' }} </label> </label> 
              
                <label class="col-6" >Isspol: <label :class="data.item.estadoJson.isspol? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.isspol? 'Activo' : 'Inactivo' }} </label> </label> 
                <label class="col-6">Particular: <label :class="data.item.estadoJson.particular? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.particular? 'Activo' : 'Inactivo' }} </label> </label> 
              </div>
            </template>
            <template #cell(establecimientos)="data">
              <div class="d-flex flex-column">
                <span
                  v-for="est in data.item.establecimientos"
                  :key="est.id"
                >
                  {{ est.nombre }}:
                  <span :class="est.activo ? 'text-success' : 'text-danger'">
                    {{ est.activo ? 'Activo' : 'Inactivo' }}
                  </span>
                </span>
              </div>
            </template>
            <template #cell(descripcion)="data">
              <div :id="'tooltip-target-' + data.index" v-b-tooltip.hover :title="data.item.descripcion">
                {{ truncateTexto(data.item.descripcion, 50) }}
              </div>
            </template>
            
            <template #cell(acciones)="data">
              <div class="d-flex justify-content-end">
                <!-- Asegúrate de usar la propiedad correcta aquí, por ejemplo, `idImagen` -->
                <b-button
                  variant="info"
                  size="sm"
                  @click="viewItem(data.item.tokenProcedimiento)"
                >
                  <font-awesome-icon
                    icon="magnifying-glass"
                    style="color: white"
                  />
                </b-button>
                <b-button
                  variant="primary"
                  size="sm"
                  @click="editItem(data.item.tokenProcedimiento)"
                >
                  <font-awesome-icon icon="user-pen" style="color: white" />
                </b-button>
            
              </div>
            </template>
          </b-table>
          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col cols="12" class="mb-2">
          <b-pagination
            v-if="items.length > 0"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            :small="true"
            first-number
            last-number
            class="mb-0"
            align="center"
            prev-class="prev-item"
            next-class="next-item"
            @change="cambiarPagina"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card>
    </b-overlay>
    <b-modal id="editar-procedimiento" size="lg" hide-footer no-close-on-backdrop>
        <Editarprocedimiento
          :key="tokenSeleccionado || 'nuevo-proc'"
          ref="editarProcedimientoRef"
          :tokenSeleccionado="tokenSeleccionado"
        />
    </b-modal>
    <b-modal
      v-model="modalShow"
      @show="cargarComponente"
      title="Detalles del Procedimiento"
      size="lg"
    >
      <component
        :is="componenteDinamico"
        v-if="componenteDinamico"
        :token="tokenSeleccionado"
      ></component>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BOverlay,
  BFormGroup,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
} from "bootstrap-vue";
import actions from "@/assets/utils/utils";
import BCardCode from "@core/components/b-card-code";
import vSelect from "vue-select";
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import Editarprocedimiento from "./EditarprocedimientoV2.vue";
import { getEstablecimientoLS } from "@/shared/helpers";

export default {
  components: {
    BCard,
    BCardCode,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BOverlay,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BModal,
    Editarprocedimiento,
  },
  data() {
    return {
      idEstablecimiento:null,
      currentEstablecimiento: getEstablecimientoLS && getEstablecimientoLS(),
      tokenSeleccionado: null,
      modalShow: false,
      componenteDinamico: null,
      pagina_actual: 1,
      currentPage: 1,
      currentPageModificado: 1,
      mostrarLoader: false,
      login_user: "",

      consultarprocedimiento: null,
      consultarestablecimiento: "",
      consultarespecialidad: "",
      especialidades: [],

      establecimientos: [],
      establecimiento: "",
      establecimientosList: [],
      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 3,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        { key: "estadoJson", label: "Estado", sortable: true, thClass: "text-center" },
        { key: "establecimientos", label: "Establecimiento", sortable: true, thClass: "text-center" },
        { key: "descripcion", label: "Descripcion", sortable: true, thClass: "text-center" },
        { key: "especialidad", label: "Especialidades", sortable: true, thClass: "text-center" },
        { key: "codigo", label: "Codigo", sortable: true, thClass: "text-center" },
        { key: "usuario", label: "Usuario", sortable: true, thClass: "text-center" },
        { key: "acciones", label: "acciones", sortable: true, thClass: "text-center", tdClass: "text-right" },
      ],
      listaAcciones: [],
      token_usuario: "",
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "d/m/Y",
      },
      items: [],
      descripcion: "",
    };
  },
  created() {
    const user = JSON.parse(localStorage.getItem('detalleusuario'))
    this.idEstablecimiento = user.establecimiento ? user.establecimiento.id : ""
    this.currentEstablecimiento = user.establecimiento || null;
    this.fetchConsultarProcedimiento();
    this.setToken();
    this.fetchEspecialidades();
    this.fetchEstablecimientos();
  },
  mounted() {
    actions.setearTitulo("Procedimiento Clinico");
    this.fetchConsultarProcedimiento();
  },

  methods: {
    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.establecimientosList = response.data.data.allEstablecimientos.map(
          (item) => ({
            value: item.id,
            text: item.Descripcion,
            uniCodigo: item.uniCodigo,
          })
        );
        this.establecimientos = this.establecimientosList;
      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },
    viewItem(tokenProcedimiento) {
      this.tokenSeleccionado = tokenProcedimiento;
      this.modalShow = true;
    },
    cargarComponente() {
      // Cargar dinámicamente el componente cuando se muestra el modal
      import("./Verprocedimiento.vue")
        .then((componente) => {
          this.componenteDinamico = componente.default;
        })
        .catch((error) => {
          console.error("Error al cargar el componente:", error);
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      console.log("llegamos ", this.currentPage);
    },
    cambiarPagina(pagina_actual) {
     
      // Actualizar currentPage con el nuevo número de página
      this.currentPage = pagina_actual;
      
      console.log("per page", this.perPage)
     
      const especialidadValue = this.consultarespecialidad
        ? this.consultarespecialidad.toString()
        : "";

      this.fetchConsultarProcedimiento(
        this.consultarprocedimiento ? this.consultarprocedimiento : "",
        this.currentPage,
        this.currentEstablecimiento && this.currentEstablecimiento.uniCodigo === '36451'
          ? this.consultarestablecimiento
          : this.idEstablecimiento,
        especialidadValue,
        this.perPage
      );
      
    },
    
    async fetchEspecialidades() {
      
      const query = `
                        query {
                            allEspecialidades {
                                id
                                descripcion
                            }
                        }
                    `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.especialidades = response.data.data.allEspecialidades.map(
          (item) => ({
            value: item.id,
            text: item.descripcion,
          })
        );
      } catch (error) {
        console.error("An error occurred while fetching the options:", error);
      }
    },

    async fetchConsultarProcedimiento(
      
      search = "",
      pagina_actual = this.currentPageModificado,
      establecimiento = "",
      especialidad = "",
      pageSize
    ) {
      
      

      const query = `
        query GetAllProcedimientos(
          $search: String
          $establecimiento: String
          $especialidad: String
          $page: Int
          $pageSize: Int
        ) {
          allProcs(
            search: $search
            establecimiento: $establecimiento
            especialidad: $especialidad
            page: $page
            pageSize: $pageSize
          ) {
            total
            status
            message
            procedimiento{
              id
              token
              descripcion
              establecimiento
              especialidad {
                id
                descripcion
              }
              codigo
              estado
              precio
              precioJson
              estadoJson
            }
            pageInfo {
              currentPage
              totalPages
              hasNextPage
              hasPreviousPage
            }
          }
        }
      `;
      const var_consulta = {
        search: search,
        page: pagina_actual,
        pageSize: pageSize,
        establecimiento: this.currentEstablecimiento && this.currentEstablecimiento.uniCodigo === '36451'
          ? (establecimiento || null)
          : (this.idEstablecimiento ? this.idEstablecimiento.toString() : null),
        especialidad: especialidad.toString(),
      };

      console.log("variables que envio", var_consulta)
      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: var_consulta,
        });
        console.log(response);

        if (response.status === 200) {
          if (response.data.data.allProcs.status === "Success") {
            if (response.data.data.allProcs.procedimiento) {
              this.items = response.data.data.allProcs.procedimiento.map(
                (item) => {
              let precioJson = item.precioJson;
              let estadoJson = item.estadoJson;
              try {
                precioJson = JSON.parse(item.precioJson);
              }catch(error){ console.log("error precioJson", error); }

              try {
                estadoJson = JSON.parse(item.estadoJson);
              }catch(error){ console.log("error estadoJson", error); }

              const estabIds = (item.establecimiento || '').split(',').map(e => e.trim()).filter(Boolean);
              const estabList = this.establecimientosList.length
                ? this.establecimientosList.map(est => ({
                    id: est.value ? String(est.value) : '',
                    nombre: est.text,
                    activo: estabIds.includes(String(est.value))
                  }))
                : estabIds.map(id => ({ id, nombre: id, activo: true }));

              const estadosParsed = estadoJson && typeof estadoJson === 'object' ? estadoJson : {
                iess: item.estado === '1',
                issfa: item.estado === '1',
                isspol: item.estado === '1',
                particular: item.estado === '1'
              };

              return {
                idProcedimiento: item.id,
                tokenProcedimiento: item.token,
                descripcion: `${item.codigo} ${item.descripcion}`,
                establecimientos: estabList,
                especialidad: item.especialidad.descripcion,
                codigo: item.codigo,
                precioJson: precioJson,
                estadoJson: estadosParsed,
                usuario: item.usuarioCreador ? item.usuarioCreador.username : "No disponible",
              };
                }
              );
              console.log("yey", this.items);

              this.totalRows = response.data.data.allProcs.total;
              //this.currentPage = 1;
              this.currentPageModificado = pagina_actual;
            } else {
              console.log("No se encontraron procedimientos");
              // Aquí podrías establecer un mensaje en la interfaz de usuario
            }
          } else {
            console.log("Error en la respuesta del servidor");
            // Manejo del error de respuesta del servidor
          }
        }
      } catch (error) {
        console.error("Error fetching procedimiento:", error);
        // Aquí también podrías mostrar un mensaje de error en la interfaz de usuario
      }
    },
    buscarProcedimiento() {
      const establecimientoValue = this.consultarestablecimiento
        ? this.consultarestablecimiento.toString()
        : "";
      const especialidadValue = this.consultarespecialidad
        ? this.consultarespecialidad.toString()
        : "";
      this.fetchConsultarProcedimiento(
        this.consultarprocedimiento ? this.consultarprocedimiento : "",
        this.currentPage,
        this.currentEstablecimiento && this.currentEstablecimiento.uniCodigo === '36451'
          ? establecimientoValue
          : this.idEstablecimiento,
        especialidadValue,
        15,
        "",
        ""
      );
    },

   
    editItem(tokenProcedimiento) {
      this.tokenSeleccionado = tokenProcedimiento
      this.$bvModal.show('editar-procedimiento')
      this.$nextTick(() => {
        if (this.$refs.editarProcedimientoRef?.fetchProcedimiento) {
          this.$refs.editarProcedimientoRef.fetchProcedimiento(tokenProcedimiento)
        }
      })
      
    },
    removeItemid(idProcedimiento) {
      const mesa = this.fetchRemoveProcedimiento(idProcedimiento);
    },
   
    setToken() {
      const user = JSON.parse(localStorage.getItem("usuario"));
      this.login_user = user.username;
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },

    truncateTexto(texto, maxLength = 50) {
      if (!texto) return '';
      return texto.length > maxLength ? `${texto.slice(0, maxLength)}...` : texto;
    }
  },

  computed: {
    isXima() {
      return this.currentEstablecimiento?.uniCodigo === '36451';
    },
  },
};
</script>
